import { makeGetRequest } from 'owa-ows-gateway';
import { PremiumUserResponse } from '../contracts/premiumUserResponse';

const getPremiumUserUrl: string = 'ows/api/beta/PremiumUser/';

export async function getPremiumUser(): Promise<PremiumUserResponse> {
    let response = await makeGetRequest(getPremiumUserUrl);
    return response;
}
